<ca-modal-container
    modalTitle="{{ 'MY_WORKSPACE.MY_RESULTS.SHARING.TITLE' | translate }}"
    description="{{ 'MY_WORKSPACE.MY_RESULTS.SHARING.SUBTITLE' | translate }}"
    (dismiss)="dismiss()"
>
    <ca-share-with-user [share]="share" (save)="save($event)"></ca-share-with-user>
</ca-modal-container>
